import { UniqueIdentifier } from "@dnd-kit/core";
import {
  AdminCustomerLocationResDto,
  AdminGetRoutesResDto,
} from "service/api/estabrookSchemas";
import { OrderStatuses } from "../../../../components/map/map.types";

export function findContainer(
  id: UniqueIdentifier,
  data: AdminGetRoutesResDto[],
) {
  if (!id) return null;
  const idStr = id.toString();

  // A live timeline can contain several chronological runs of one status.
  // All runs still target the same route/status for drag-and-drop updates.
  const liveGroup = idStr.match(/^(.+)::\d+-(regular|delayed)$/);
  if (liveGroup) return `${liveGroup[1]}-${liveGroup[2]}`;

  // Check if id is already a container id (format: route-id-status)
  if (/-(?:regular|delayed|skipped)$/.test(idStr)) {
    return idStr;
  }

  // Find the route containing this location id
  const route = data.find((route) =>
    route.locations?.some((location) => location.locationId === idStr),
  );

  if (!route) return null;

  // Find the location to get its status
  const location = route.locations?.find((loc) => loc.locationId === idStr);
  if (!location || !location.order?.status) return null;

  // Return container id in format: route-id-status
  return `${route.id}-${location.order.status.toLowerCase()}`;
}

export const showCustomerStatus = (status: string) => {
  if (status === OrderStatuses.Regular) {
    return "Home";
  } else if (status === OrderStatuses.Delayed) {
    return "Delay";
  }

  return "Skip";
};

export const showCustomerType = (type: AdminCustomerLocationResDto["type"]) => {
  if (type === "onDemand") {
    return "On Demand";
  }

  return "Flat Rate";
};
